themes_handler = {

    properties: {
        gauges: {
            time_walking_biking: '',
            time_transit: '',
            time_driving: '',
            reliability_walking_biking: '',
            reliability_transit: '',
            reliability_driving: '',
            safety_walking_biking: '',
            safety_transit: '',
            safety_driving: ''
        }
    },

    onLoad: function(){
        var self = this;

        $('#content-root, #map').removeClass('swipe');
        $('#content-root').addClass('large secondary-bg background-img');


    },

   
    events: function() {
        var self = this;
        self.onLoad();

    }
}
